import { callJWebWithTimeout } from '../utils/callJWebWithTimeout';
import { JWebCoreFacade } from './JWebCoreFacade';

/**
 * Facade for ContainerPlugin operations (Only Native)
 */
export class ContainerPluginFacade {
  private static jWebContainerInstanceId = (async () => {
    return await ContainerPluginFacade.getInstanceId();
  })();

  public static async getInstanceId(): Promise<string> {
    try {
      const JWeb = await JWebCoreFacade.getJWeb();

      if (!JWeb.isNative) {
        return undefined;
      } else if (!JWeb?.Plugins?.Container?.getInfo) {
        console.error(
          'JWeb error: JWeb.Plugins.Container.getInfo() is not available'
        );
        return undefined;
      }

      const containerInfo = await callJWebWithTimeout(
        JWeb?.Plugins?.Container?.getInfo
      );

      if (containerInfo === false) {
        console.warn('JWeb.Plugins.Container.getInfo() timed out or failed');
        return undefined;
      }

      return containerInfo?.instanceId;
    } catch (e) {
      console.error(
        'JWeb error: Failed to get JWeb.Plugins.Container.getInfo. ',
        e
      );
      return undefined;
    }
  }

  /**
   * Get the JWeb container instance ID
   */
  public static async getJWebContainerInstanceId(): Promise<
    string | undefined
  > {
    return this.jWebContainerInstanceId;
  }
}
